module.exports = __webpack_public_path__ + "assets/can_be_better.54c920fb21ab30c64a001c06486768d5.png";